export default __webpack_public_path__ + "static/media/Ballroll_00131.4d9c785c.png";